import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  videoBox: {
    backgroundColor: "#000",
    width: "40%",
    flexShrink: 0,
    alignItems: "center",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  bottomSection: {
    display: "flex",
    flexGrow: 1,
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      flexWrap: "wrap",
      overflow: "scroll",
    },
  },
}))

export default styles
